import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Schema, Checkbox, InputGroup } from 'rsuite';
import { TextField } from '../../helpers/FormControlRSuit';

import { startLogout, startRegister, startRegisterContrato } from '../../actions/auth';
import 'animate.css';
import { MaskedInputPhone } from '../../helpers/formControlInputs';

const { StringType, NumberType} = Schema.Types;

let model = Schema.Model();

export const RegisterForm = () => {
    let history = useHistory();
    const dispatch = useDispatch();
    const cliente = useSelector(state => state.client);

    const [step, setStep] = useState(1);
    const [formValue, setFormValue] = useState({
        correo: '',
        password1: '',
        password2: '',
        dia: '',
        mes: '',
        anio: '',
        celular: '',
        casa: '',
        emergencia: '',
        tutor: '',
        enfermedades: '',
        acepto: '',
        compania: '',
    });
    const [formError, setFormError] = useState({});
    const [form, setform] = useState({})

    const handleNext = () => {
        window.scrollTo(0, 0);
        setStep(step + 1);
    };

    const handleLogout = () => {
        setTimeout(() => {
            dispatch(startLogout());
            history.push("/login");
        }, 3000);
    };

    const handleSubmit = async() => {
        if (!form.check()) {
            console.error(formError);
            return;
        }
        switch (step) {
            case 2:
                const resp = await dispatch(startRegister(cliente.folio, formValue));
                if(!resp) return;
                break;
            case 3:
                const respContrato = await dispatch(startRegisterContrato(cliente.folio));
                if(!respContrato) return;
                break;
        }
        handleNext();
    }

    switch (step) {
        case 4:
            handleLogout();
            return(
                <div className="row">
                    <div className="col-12">
                        <div className="text-center">
                            <h2 className="mt-0">
                                <i className="fa fa-check fa-3x"></i>
                            </h2>
                            <h3 className="mt-0">Gracias !</h3>

                            <p className="w-75 mb-2 mx-auto">Felicidades Ahora formas parte de SkyTeens.</p>

                        </div>
                    </div>
                </div>
            );
        case 3:
            model = Schema.Model({
                acepto: StringType()
                  .isRequired('Es necesario que leas y aceptes tu contrato.'),
            });
            return (
                <Form
                    fluid
                    ref={ref => (setform(ref))}
                    onChange={formValue => {
                    setFormValue(formValue);
                    }}
                    onCheck={formError => {
                    setFormError(formError);
                    }}
                    formValue={formValue}
                    model={model}
                    inline
                >
                    <div className="row">
                        <div className="col-12">
                            <div className="text-center">
                                <h3 className="mt-0">¡ Tu contrato esta listo !</h3>
                                <p className="w-75 mb-4 mx-auto">Lee cuidadosamente tu contrato antes de aceptar el mismo.</p>
                                <div className="row mb-3"  dangerouslySetInnerHTML={{__html: cliente.contrato}}></div>
                                <div className="row mb-3">
                                    <TextField 
                                        name="acepto"
                                        accepter={Checkbox}
                                        value={'1'}
                                    >
                                        Estoy deacuerdo con el contrato anterior.
                                    </TextField>
                                </div>
                            </div>
                        </div>
                        {/* end col */}
                    </div>
                    {/* end row */}
                    <button type="button" onClick={handleSubmit} className="btn btn-primary btn-lg btn-block">Continuar</button>
                </Form>
            );
        case 2:
            model = Schema.Model({
                correo: StringType()
                    .isRequired('El Correo es requerido.')
                    .isEmail('Tiene que ser un correo'),
                password: StringType()
                    .isRequired('La contraseña es requerida')
                    .minLength(8, 'Minimo 8 caracteres'),
                password2: StringType()
                    .isRequired('La contraseña es requerida')
                    .addRule((value, data) => {
                        if (value !== data.password) {
                        return false;
                        }
                        return true;
                    }, 'La contraseña no coincide'),
                anio: NumberType()
                    .pattern(/^[1-2][9,0][0-9]{2}$/, 'El año no es valido'),
                mes: NumberType()
                    .range(1,12, 'El més no es valido'),
                dia: NumberType()
                    .range(1,31, 'El día no es valido'),
                celular: StringType()
                    .isRequired('Es requerido'),
                casa: StringType()
                    .isRequired('Es requerido'),
                emergencia: StringType()
                    .isRequired('Es requerido'),
                tutor: StringType()
                    .isRequired('Es requerido'),
            });
            return (
                <div className="h-100">
                    <Form
                        fluid
                        ref={ref => (setform(ref))}
                        onChange={formValue => {
                        setFormValue(formValue);
                        }}
                        onCheck={formError => {
                        setFormError(formError);
                        }}
                        formValue={formValue}
                        model={model}
                    >
                        <div className="row mb-4">
                            <div className="col-12">
                                <div className="text-left">
                                    <p className="mb-2 mx-auto">Para comenzar necesitamos algunos datos personales, esto es para generar tu contrato personalizado y saber un poco más de ti.</p>
                                    <p className="mb-2 mx-auto">Todos tus datos estaran protegidos, puedes revisar nuestro <a href="https://viveskygest.com">Aviso de Privacidad</a>.</p>
                                </div>
                            </div>
                            {/* end col */}
                        </div>
                        <div className="row mb-3">
                            <div className="col-md-6">
                                <div className="form-group mb-0">
                                    <label className="" htmlFor="nombre-input">Nombre</label>
                                    <input type="text" readOnly={true} className="form-control-plaintext text-info form-control-lg" id="nombre-input" value={cliente.nombre} />
                                </div>
                            </div> {/* end col */}
                            <div className="col-md-6">
                                <div className="form-group mb-0">
                                    <label className="" htmlFor="nombre-input">No. de Viajero</label>
                                    <input type="text" name="folio" readOnly={true} className="form-control-plaintext text-info form-control-lg" id="folio-input" value={cliente.folio} />
                                </div>
                            </div> {/* end col */}
                            <div className="col-md-6">
                                <div className="form-group mb-0">
                                    <label className="" htmlFor="esculea-input">Escuela</label>
                                    <input type="text" id="esculea-input" readOnly={true} className="form-control-plaintext text-info form-control-lg" value={cliente.escuela} required={true} />
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="form-group mb-0">
                                    <label className="" htmlFor="grupo-input">Grupo</label>
                                    <input type="text" id="grupo-input" readOnly={true} className="form-control-plaintext text-info form-control-lg" value={cliente.grupo} required={true} />
                                </div>
                            </div>
                            <div className="col-md-3 col-6">
                                <div className="form-group mb-0">
                                    <label className="" htmlFor="turno-input">Turno</label>
                                    <input type="text" id="turno-input" readOnly={true} className="form-control-plaintext text-info form-control-lg" value={cliente.turno} required={true} />
                                </div>
                            </div>
                        </div> {/* end row */}

                        <fieldset>
                            <div className="row">
                                <div className="col-md-7">
                                    <TextField 
                                        label="Correo"
                                        name="correo"
                                        placeholder="Correo electronico"
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <TextField 
                                        label="Contraseña"
                                        name="password"
                                        type="password"
                                        placeholder="Contraseña"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <TextField 
                                        label="Repetir contraseña"
                                        name="password2"
                                        type="password"
                                        placeholder="Contraseña"
                                    />
                                </div>
                                <small className="ml-2" style={{fontSize: '0.7rem'}}><span className="d-none1d-sm-inline">Crea tu contraseña para entrar a tu perfil </span>(minimo 8 caracteres).</small>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <div className="form-group mb-0">
                                        <label>Fecha de nacimiento</label>
                                        <InputGroup 
                                            name="fecha"
                                        >
                                            <TextField
                                                placeholder="Día"
                                                name="dia"
                                                inline={true}
                                                type="number"
                                            />
                                                <InputGroup.Addon>/</InputGroup.Addon>
                                            <TextField 
                                                placeholder="Més"
                                                name="mes"
                                                inline={true}
                                                type="number"
                                            />
                                                <InputGroup.Addon>/</InputGroup.Addon>
                                            <TextField 
                                                placeholder="Año"
                                                style={{width: '5em'}}
                                                name="anio"
                                                inline={true}
                                                type="number"
                                            />
                                        </InputGroup>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-6">
                                    <TextField 
                                        accepter={MaskedInputPhone}
                                        label="Celular"
                                        name="celular"
                                    />
                                </div>
                                <div className="col-md-6">
                                    <TextField 
                                        accepter={MaskedInputPhone}
                                        label="Telefono de casa"
                                        name="casa"
                                    />
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-md-4">
                                    <TextField 
                                        accepter={MaskedInputPhone}
                                        label="Telefono de emergencia"
                                        name="emergencia"
                                    />
                                </div>
                                <div className="col-md-8">
                                <TextField 
                                    label="Nombre del padre o tutor"
                                    name="tutor"
                                />
                                </div>
                            </div>textarea
                            <div className="row mt-2 mb-2">
                                <div className="col-md-12">
                                    <label className="control-label">
                                            ¿Padece alguna enfermedad o alergias?
                                    </label>
                                    <TextField 
                                        label="Platícanos:"
                                        name="enfermedades"
                                        componentClass="textarea"
                                        rows={5}
                                    />
                                </div>
                            </div>
                        </fieldset>
                        <button type="button" onClick={handleSubmit} className="btn btn-primary btn-lg btn-block">Continuar</button>
                    </Form>
                </div>
            )
    
        default:
            model = Schema.Model({
                compania: StringType()
                  .isRequired('Es necesario que estés con un mayor de edad.'),
            });
            return (
                <div className="h-100">
                    <div className="text-center">
                        <i className="fa fa-map-signs fa-4x" aria-hidden="true"></i>
                    </div>
                    <h3 className="mt-2 text-center">¡ Aquí comienza el viaje !</h3>
                    <hr/>
                    <p className="mb-2 mx-auto">Hola <strong>{cliente.nombre}</strong>, si eres menor de edad antes de empezar requerimos que estés acompañado de tu padre o tutor legal.</p>

                    <Form
                        fluid
                        ref={ref => (setform(ref))}
                        onChange={formValue => {
                        setFormValue(formValue);
                        }}
                        onCheck={formError => {
                        setFormError(formError);
                        }}
                        formValue={formValue}
                        model={model}
                    >

                        <div className="row mb-5">
                            <div className="col">
                                <TextField 
                                    name="compania"
                                    accepter={Checkbox}
                                    value={'1'}
                                >
                                    Estoy en compañía de alguno de mis padres o tutores.
                                </TextField>

                            </div>
                        </div>
                        <button type="button" onClick={handleSubmit} className="btn btn-primary btn-lg btn-block">Continuar</button>
                    </Form>
                </div>
            )
    }
}
